import { RequestEvent } from 'common/event';
import { LookupItem } from 'runtime/data/lookupitem';

export class LookupItemRequested extends RequestEvent<LookupItemRequested, LookupItem> {
    constructor(public fieldName: string, public fieldContext: string, public keyValue: string) {
        super();
    }
}